module.exports = __webpack_public_path__ + "static/media/img_04.57b4eeed.png";